// eslint-disable-next-line import/prefer-default-export
export const routes = [
  {
    path: '/project/:alias/:projectAlias',
    name: 'project'
  }
];
